import { CircularProgress, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomWidthTooltip, useImageTooltipClasses } from "./ImageTooltip.style";

type ImageTooltipProps = {
  children?: React.ReactNode;
  imagePath: string;
  imageStyle?: {};
  imageContext?: "drawing" | undefined;
  placement?:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
  customCondition?: boolean | undefined;
  useCustomCondition?: boolean | undefined;
};


const ImageTooltip = function (props: ImageTooltipProps) {

  const [imgPath, setImagePath] = useState<string | undefined>();
  const [imgStyle, setImgStyle] = useState<React.CSSProperties | undefined
  >();

  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  useEffect(() => {
     setImagePath(props.imagePath);
    setImgStyle(props.imageStyle!== undefined ? props.imageStyle:{});
    
  }, [props.imagePath, props.imageContext]);

  
  const classes = useImageTooltipClasses();

  return (props.useCustomCondition === true &&
    props.customCondition === true) ||
    (props.useCustomCondition !== true ) ? (
    <CustomWidthTooltip
      placement={props.placement ? props.placement : "right-end"}
      disableInteractive
      title={
        !imageLoaded ? (
          <>
            <CircularProgress
              color="primary"
              style={{
                width: "30px",
                height: "30px",
                margin: "20px",
              }}
            />
            <div style={{ display: "none" }}>
              <div>
                <img src={imgPath} onLoad={(evt) => setImageLoaded(true)} />
              </div>
            </div>
          </>
        ) : (
          <div style={imgStyle} key="image">
            <img alt="" src={imgPath} style={imgStyle} />
          </div>
        )
      }
      sx={classes.tooltip}
    >
      <span>{props.children}</span>
      </CustomWidthTooltip>
  ) : (
    <>{props.children}</>
  );
};

export default ImageTooltip;


